import { render } from "./modal-storico-task.vue?vue&type=template&id=683f13de&scoped=true"
import script from "./modal-storico-task.vue?vue&type=script&lang=js"
export * from "./modal-storico-task.vue?vue&type=script&lang=js"

import "./modal-storico-task.vue?vue&type=style&index=0&id=683f13de&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-683f13de"]])

export default __exports__